
import React from 'react';

export default function HowToApply() {
  const steps = [
    {
      step: 1,
      title: '公式サイトにアクセス',
      description: 'dカード公式サイトの「dカード GOLD U」申込みページにアクセスします。'
    },
    {
      step: 2,
      title: '必要事項を入力',
      description: '氏名、住所、勤務先情報、年収などの必要事項を入力します。dアカウントがあるとスムーズです。'
    },
    {
      step: 3,
      title: '本人確認',
      description: '運転免許証やマイナンバーカードなどで本人確認を行います。オンラインで完結可能。'
    },
    {
      step: 4,
      title: '審査',
      description: '入力内容をもとに審査が行われます。審査結果はメールで通知されます。'
    },
    {
      step: 5,
      title: 'カード発行・受取',
      description: '審査通過後、約1〜2週間でカードが届きます。届いたらすぐに利用開始できます。'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          申込み方法
        </h2>
        <p className="text-center text-gray-600 mb-12">
          オンラインで簡単に申込みできます
        </p>

        <div className="space-y-6">
          {steps.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-6 bg-gray-50 rounded-xl p-6"
            >
              <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-lg">{item.step}</span>
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#003366] mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 入会特典 */}
        <div className="mt-12 bg-gradient-to-r from-[#E60033] to-[#FF4D6D] rounded-xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-4 text-center">入会&利用特典</h3>
          <div className="text-center mb-6">
            <p className="text-lg mb-2">合計最大</p>
            <p className="text-5xl font-bold mb-2">
              7,000<span className="text-2xl">ポイント</span>
            </p>
            <p className="text-sm text-white/80">
              dポイント（期間・用途限定）プレゼント
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="bg-white/20 rounded-lg p-4">
              <p className="font-bold mb-1">入会翌々月までの利用で</p>
              <p className="text-2xl font-bold">最大3,000ポイント</p>
            </div>
            <div className="bg-white/20 rounded-lg p-4">
              <p className="font-bold mb-1">公共料金支払い設定で</p>
              <p className="text-2xl font-bold">最大4,000ポイント</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
